<template>
  <!-- 这个是基本信息 -->
  <div class="main">
    <div class="main_box">
      <div class="main_title">{{ $t("info.basicinfo") }}</div>

      <div class="list_box">
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("info.type") }}
        </div>
        <div class="radio_btn">
          <el-radio @change="" v-model="radio" label="0">{{
            $t("info.individual_person")
          }}</el-radio>
          <el-radio @change="" v-model="radio" label="1">{{
            $t("info.company")
          }}</el-radio>
        </div>
      </div>

      <div class="list_box name MG25" v-if="radio == 0">
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("info.name") }}
        </div>
        <div :class="compellations && !compellation.lastname ? 'TGA_BR' : ''">
          <input
            v-model="compellation.lastname"
            class="TGA_INPUT input"
            type="text"
          />
        </div>
        <div class="">
          <span class="must">*</span>
          {{ $t("info.surname") }}
        </div>
        <div :class="compellations && !compellation.firstname ? 'TGA_BR' : ''">
          <input
            v-model="compellation.firstname"
            class="TGA_INPUT input"
            type="text"
          />
        </div>

        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="compellations">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span>{{ $t("info.empty_name") }}</span>
        </div>
      </div>

      <div
        class="list_box MG25"
        v-if="radio == 1"
        :class="accountNames ? 'TGA_BR' : ''"
      >
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("info.enterprise") }}
        </div>
        <div>
          <input v-model="accountName" type="text" class="TGA_INPUT input367" />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="accountNames">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span>{{ $t("info.empty_enterprise") }}</span>
        </div>
      </div>

      <div class="list_box name MG25 elm_site">
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("info.location") }}
        </div>
        <div :class="location && country == null ? 'TGA_BR' : ''">
          <!-- <select  class="select TGA_SELECT" :class="country !=null ? 'SelectPlaceholder':''" style="" v-model='country' @change="province=null,city=null">
            <option class="selectoption" disabled="disabled" :value="null">请选择</option>
             <option class="selectoption" v-for='(item, index) in product' :value="index">{{item.country}}</option>
          </select> -->
          <el-select
            class=""
            v-model="country"
            @change="(province = null), (city = null)"
            :placeholder="$t('info.select')"
          >
            <el-option
              v-for="(item, index) in product"
              :key="index"
              :label="item.country"
              :value="index"
            ></el-option>
          </el-select>
        </div>
        <div :class="location && province == null ? 'TGA_BR' : ''">
          <!--  <select  class="select TGA_SELECT" :class="province !=null ? 'SelectPlaceholder':''" style="" v-model='province' @change="city=null">
            <option class="selectoption" disabled="disabled" :value="null">请选择</option>
          <option class="selectoption" v-for='(item, index) in typeArray' :value="index">{{item.province}}</option>
        </select> -->
          <el-select
            class=""
            v-model="province"
            @change="city = null"
            :placeholder="$t('info.select')"
          >
            <el-option
              v-for="(item, index) in typeArray"
              :key="index"
              :label="item.province"
              :value="index"
            ></el-option>
          </el-select>
        </div>
        <div :class="location && city == null ? 'TGA_BR' : ''">
          <el-select class="" v-model="city" :placeholder="$t('info.select')">
            <el-option
              v-for="(item, index) in nameArray"
              :key="index"
              :label="item.city"
              :value="index"
            ></el-option>
          </el-select>
        </div>

        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="location">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span>{{ $t("info.select_location") }}</span>
        </div>
      </div>

      <div class="list_box MG25" :class="sites ? 'TGA_BR' : ''">
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("info.site") }}
        </div>
        <div>
          <input v-model="site" type="text" class="TGA_INPUT input367" />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="sites">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span>{{ $t("info.select_site") }}</span>
        </div>
      </div>

      <div class="list_box MG25" :class="phones ? 'TGA_BR' : ''">
        <div class="list_title">
          <span class="must">*</span>
          {{ $t("info.phone") }}
        </div>
        <div class="phone_BOX" style="height: 40px">
          <el-select class="phone_select" v-model="area"
            ><el-option
              v-for="(item, index) in configarea"
              :key="index"
              :label="item"
              :value="index"
            ></el-option
          ></el-select>

          <input
            type="text"
            v-model="phone"
            :placeholder="$t('info.select_phone')"
            class="TGA_INPUT classphone"
            style="height: 40px"
          />
        </div>
        <div class="TGA_INPUT_INIT" style="height: 40px" v-if="phones">
          <img width="15" height="15" src="@/img/mistake.png" alt="" />
          <span>{{ $t("info.empty_phone") }}</span>
        </div>
      </div>

      <div class="CU btn" @click="preservation">{{ $t("info.next") }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configarea from "@/config/area.json";
import configsite from "@/config/site.json";
export default {
  data() {
    return {
      configarea: configarea,
      radio: "0",
      compellation: {
        lastname: null,
        firstname: null,
      },
      // 国家
      country: null,
      // 省
      province: null,
      // 市
      city: null,
      //地址
      site: null,
      // 电话
      phone: null,
      // 开户名
      accountName: null,
      // 电话区号
      area: 0,

      location: false,
      compellations: false,
      sites: false,
      phones: false,
      accountNames: false,
      product: configsite,
    };
  },
  computed: {
    //获取省
    typeArray() {
      console.log(
        this.country !== null ? this.product[this.country].type : null
      );
      return this.country !== null ? this.product[this.country].type : null;
    },
    // 获取市
    nameArray() {
      return this.province !== null && this.typeArray.length
        ? this.typeArray[this.province].name
        : null;
    },
  },

  created() {
    this.keys();
  },
  methods: {
    ...mapActions("user", ["tipMessage", "EssentialInfo", "updateUserInfoExt"]),
    keys() {
      var self = this;
      document.onkeydown = (e) => {
        if (e.keyCode === 13 && self.$route.path == "/info") {
          //回车后执行搜索方法
          this.preservation();
        }
        return;
      };
    },
    // 点击保存
    async preservation() {
      if (!this.check()) {
        return;
      }
      var area = {
        province: this.province,
        city: this.city,
        country: this.country,
      };
      var obj = {
        groupType: Number(this.radio),
        groupName: "",
        area: area,
        phone: this.phone,
        // countryCode: JSON.stringify(this.area),
        countryCode: this.area,
        address: this.site,
      };
      if (this.radio == 0) {
        // obj.groupName = JSON.stringify(this.compellation);
        obj.groupName = this.compellation;
        var data = JSON.stringify(obj);
        localStorage.setItem("obj", data);
        this.$router.push({
          path: "/agreement",
        });
      } else {
        obj.groupName = { company: this.accountName };
        let res = await this.updateUserInfoExt({
          $axios: this.$axios,
          key: "baseInfo",
          value: obj,
        });
        if (res.code == 200) {
          if (
            localStorage.getItem("roleName") &&
            localStorage.getItem("roleName").includes("GAME_DEVELOPER")
          ) {
            this.$router.push({
              path: "/game_management",
            });
          } else {
            this.$router.push({
              path: "/app_management",
            });
          }
        } else {
          this.tipMessage({
            context: this.$t("info.error"),
          });
        }
      }
    },
    check() {
      var switchs = true;
      this.compellations = false;
      this.location = false;
      this.sites = false;
      this.phones = false;
      this.accountNames = false;
      if (this.radio == 0) {
        if (!this.compellation.lastname || !this.compellation.firstname) {
          this.compellations = true;
          switchs = false;
        }
      } else {
        if (!this.accountName) {
          this.accountNames = true;
          switchs = false;
        }
      }
      if (this.country == null || this.province == null || this.city == null) {
        this.location = true;
        switchs = false;
      }
      if (!this.site) {
        this.sites = true;
        switchs = false;
      }
      console.log("来了111");
      if (!this.phone || this.area == null) {
        console.log("kongl ");
        this.phones = true;
        switchs = false;
      }
      return switchs;
    },
  },
};
</script>

<style scoped="scoped">
.main {
  box-sizing: border-box;
  width: 1160px;
  height: 620px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 90px auto 0;
  display: flex;
  justify-content: center;

  /* padding: 50px 0 90px 194px; */
}
.main_box {
}
.main_title {
  margin: 72px auto 70px;
  color: #282828;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
}
.list_box {
  height: 40px;
  position: relative;
  color: #666666;
  font-size: 14px;
}
.list_title {
  width: 170px;
  height: 40px;
  line-height: 40px;
  text-align: right;
  position: absolute;
  left: -194px;
  top: 0;
}
.list_text {
  height: 40px;
  line-height: 40px;
}
.list_progress_box {
  height: 40px;
  display: flex;
  align-items: center;
}
.progress_box {
  box-sizing: border-box;
  width: 301px;
  height: 15px;
  background-color: #f3f3f3;
  border-radius: 2px;
  border: solid 1px #e5e5e5;
}
.progress {
  width: 50%;
  height: 100%;
  color: #ffffff;
  background-color: #23d3be;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list_text .text {
  color: #f65651;
  font-size: 12px;
}
.list_text .text .copy {
  color: #4990fa;
}
.main .input {
  width: 136px;
  height: 40px;
}
.name {
  width: 367px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.phone_BOX {
  display: flex;
}

.phone_BOX .classphone {
  border-radius: 0;
  width: 281px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.phone_BOX .phone_select {
  border-radius: 0;
  height: 40px;
  width: 84px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding-left: 0;
}
.btn {
  width: 367px;
  height: 50px;
  background-color: #4990fa;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 16px;
  margin-top: 30px;
}
.radio_btn {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
<style>
.phone_BOX .el-input__inner {
  box-sizing: border-box;
  height: 40px;
  /* border: none; */
  padding-left: 15px;
  font-size: 14px;
  color: rgba(28, 28, 28, 1);
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #e5e5e5;
  padding-right: 25px;
}
.phone_BOX .el-input__suffix {
  right: 0;
}
.TGA_BR .el-input__inner {
  border: solid 1px #f65651 !important;
}

.elm_site .el-input__inner {
  box-sizing: border-box;
  width: 117px;
  height: 40px;
  /* border: none; */
  padding-left: 15px;
  font-size: 14px;
  color: rgba(28, 28, 28, 1);
  border-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #e5e5e5;
  padding-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/info.vue